import { imageLinks } from 'assets/images';
import React from 'react';

interface ChatWidgetProps {
    closeWidget: () => void;
}

const ClosePrompt: React.FC<ChatWidgetProps> = ({ closeWidget }) => {

    return (
        <div
            className='close__chat'
            onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    closeWidget(); // Trigger the chat toggle on Enter or Space
                }
            }}
            role='button'
            tabIndex={0} // Makes it focusable for keyboard navigation
            aria-label='Back to Chat '
            onClick={closeWidget}>
            <img src={imageLinks?.icon?.xIcon} alt="Close" />
        </div>
    );
};

export default ClosePrompt;